import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getCommonKeywords } from '../../../../services/monitor/keywords/KeywordsService';
import { GET_ALL_COMMON_KEYWORDS } from '../../../query/keyword/keys';
import { KeywordsData } from '../../../../models/tags/TagsResponse';

export const useGetCommonKeywords = (projectId: number | null) => {
  const queryClient = useQueryClient();
  const queryEnabled = !!projectId;

  const {
    data: commonKeywords,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<KeywordsData[]>({
    queryKey: [GET_ALL_COMMON_KEYWORDS, projectId],
    queryFn: () => getCommonKeywords(projectId!),
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
    retry: 3,
    retryDelay: 1000,
  });

  const invalidate = () =>
    queryClient.invalidateQueries({
      queryKey: [GET_ALL_COMMON_KEYWORDS, projectId],
      refetchType: 'active',
    });

  return {
    commonKeywords: queryEnabled ? commonKeywords ?? [] : [],
    isLoading: queryEnabled && isLoading,
    isError: queryEnabled && isError,
    error: queryEnabled ? error : null,
    refetch,
    invalidate,
  };
};
